"use client";
import { HelpCircle, Printer } from "lucide-react";
import Link from "next/link";
import { Button } from "../ui/button";

export default function Footer() {
  return (
    <footer className="w-full border-t border-t-foreground/10 mt-auto print:hidden">
      <div className="w-full flex justify-end items-center p-3 px-5 text-sm">
        <div className="flex gap-6">
          <Button variant="ghost" onClick={() => window.print()}>
            <Printer size="1rem" /> Print
          </Button>
          <Link href="mailto:support@powersense.uk" className="flex gap-1 items-center">
            <HelpCircle size="1rem" /> Support
          </Link>
        </div>
      </div>
    </footer>
  );
}
